import React from "react";
import Tools from './utils/Tools';
import $ from 'jquery';
var strings = Tools.getStrings();

export default class WPStore extends React.Component {
    constructor(props) {
        super(props);

        $('.loadingContainerv2').show();
        this.state = {
            url:"",
            collections: [],
            collection: 0,
            openCart: false,
            lastScroll:0,
            isLogged: false,
            store_delivery_methods: [],
        };
    }

    componentDidMount() {
        window.WebApp.getInfo().getStores((result) => {
            if (result.stores.length == 0) {
              window.location.href = "/indisponivel";
            } else {
              this.setState({ stores: result.stores })}
              if(result.stores.length == 1){
                this.saveStore(result.stores[0])
              }
              this.init();
            })
       
            window.WebApp.getInfo().getStores((result) => {
                if (result.stores.length == 0) {
                  window.location.href = "/indisponivel";
                } else {
                  this.setState({ stores: result.stores }, () => {
                    if (window.deliveryScreen == "yes") {
                      window.WebApp.getAccount().getSession((session) => {
                        session = session.session;
                        if (
                          session.store == null ||
                          session.delivery_method == null ||
                          localStorage.getItem("from") == "finalize"
                        ) {
                          this.getDeliveryMethods(() => {
                            if (
                              this.state.stores.length > 1 ||
                              (this.state.store_delivery_methods.filter(
                                (e) => e.name == "delivery"
                              ) != undefined &&
                                this.state.store_delivery_methods.filter(
                                  (e) => e.name == "delivery"
                                ).length > 0)
                            ) {
                              this.setState({
                                deliveryPopup: true,
                                loading: false,
                              });
                            } else {
                              this.setState({ deliveryPopup: false, delivery_method: 2 });
                              this.saveStore(this.state.stores[0]);
                            }
                          });
                        } else {
                          this.init();
                        }
                      });
                    } else {
                      this.init();
                    }
                  });
                }
              });



        document.documentElement.style.setProperty(
            "--delivery-screen-text-color",
            window.deliveryScreenTextColor
          );
      
          document.documentElement.style.setProperty(
            "--delivery-screen-selected-text-color",
            window.deliveryScreenSelectedTextColor
          );
    }

    init(){
        window.WebApp.getAccount().authCheck((result) => {
            this.setState({
                isLogged:!result.expired,
            });
        });
        this.getProds();

        const _this = this;
        $( window ).scroll(function() {
            $('.collection-title').each(function() {
                var pageTop = $(window).scrollTop() - ($(window).height()/2 + 160);
                var pageBottom = pageTop + $(window).height();
                var elementTop = $(this).offset().top;
                var elementBottom = elementTop + $(this).height();
        
                if((pageTop < elementTop) && (pageBottom > elementBottom)) {
                    if(_this.state.collection !== $(this).data('index')) {
                        if((pageTop >= _this.state.lastScroll && _this.state.collection < $(this).data('index')) ||
                        (pageTop <= _this.state.lastScroll && _this.state.collection > $(this).data('index'))){
                            _this.setState({
                                collection: $(this).data('index')
                            });
                        }
                    }
                }
                _this.state.lastScroll = pageTop;
            })
        });

        let addedprod = localStorage.getItem('added_product');
        if(addedprod != null) {
            localStorage.removeItem('added_product');
            $('.finalize-snackbar .prodname').text(addedprod);
            $('.finalize-snackbar').stop().slideDown();
        }
    }

    getDeliveryMethods(callback) {
        window.WebApp.getCheckout().getDeliveryMethods(
          function (result) {
            this.setState(
              {
                store_delivery_methods: result.methods,
              },
              () => {
                callback && callback();
              }
            );
          }.bind(this)
        );
      }

    getProds() {
        window.WebApp.getCart().getMenusExtras((result) => {
            let collection = 0;
            let collid = 0;
            if(window.location.href.indexOf('#') > -1) {
                collid = window.location.href.split('#');
                collid = parseInt(collid[1]);
            }
            for(var i = 0; i < result.collections.length; i++) {
                if(result.collections[i].visible === 1) {
                    if(collid !== 0) {
                        if(result.collections[i].id === collid) {
                            collection = i;
                        }
                    } else {
                        collection = i;
                        break;
                    }
                }
            }
            this.setState({
                menus: result.menus,
                collections: result.collections,
                url: result.url,
                collection
            }, () => {
                $('.loadingContainerv2').hide();
                if(collid !== 0) {
                    this.chageCollection(collection);
                }
            });
        });
    }

    createMarkup(text) {
        return {__html: text};
    }

    chageCollection(collIndex) {
        $('html, body').animate({
            scrollTop: $(".collection-"+collIndex).offset().top - 250
        }, 500);
        this.setState({
            collection: collIndex,
        });
    }

    calcPrice(collIndex, prodIndex, compIndex, compProdIndex) {
        let collections = this.state.collections;
        let product = collections[collIndex].products[prodIndex];
        window.WebApp.getNetwork().getLoading().doNotLoad(-1);
        var compProds = [];
        if(product.composition !== undefined) {
            compProds = product.composition.products
        }

        let qty = 1;
        let hasqty = false;
        if(product.quantity !== undefined && product.quantity > 0) {
            qty = product.quantity;
            hasqty = true;
        }
        var toCalc = {id:product.id, name:product.name, quantity:qty, composition:{products:compProds}};
        var data = {extras:[toCalc]};
        window.WebApp.getCheckout().calculatePrice(data, (result) => {
            let newTotal = 0;
            let totalCalc = 0;
            let priceRulesDiscount = 0;
            if(this.state.type === "menu"){
                newTotal = result.menusInfo.prices[0].price;
            }else {
                newTotal = result.extrasInfo.prices[0].price;
            }
            if(compIndex !== undefined) {
                product = window.WebApp.getCart().priceForComposition(product.price,newTotal,product,compIndex,compProdIndex);
            }
            product.price = newTotal;
            if(hasqty) {
                totalCalc = product.price * product.quantity;
                priceRulesDiscount = result.menusInfo.priceRulesDiscount + result.extrasInfo.priceRulesDiscount;
                totalCalc -= priceRulesDiscount;
                product.totalCalc = totalCalc;
            } else {
                product.totalCalc = 0;
            }
            this.setState({
                collections
            });
        });
    }

    lessProduct(collIndex, prodIndex) {
        let collections = this.state.collections;
        let product = collections[collIndex].products[prodIndex];
        let qty = product.increment_quantity;
        if(product.selectedsize !== undefined && product.selectedsize.increment_quantity !== undefined) {
            qty = product.selectedsize.increment_quantity;
        }
        if(product.quantity > 0) {
            product.quantity -= qty;
            this.setState({
                collections
            }, () => this.calcPrice(collIndex, prodIndex));
        }
    }

    moreProduct(collIndex, prodIndex) {
        let collections = this.state.collections;
        let product = collections[collIndex].products[prodIndex];
        if(product.quantity === undefined) product.quantity = 0;
        let qty = product.increment_quantity;
        if(product.selectedsize !== undefined && product.selectedsize.increment_quantity !== undefined) {
            qty = product.selectedsize.increment_quantity;
        }
        product.quantity += qty;
        product.quantityerror = false;
        this.setState({
            collections
        }, () => this.calcPrice(collIndex, prodIndex));
    }

    order(collIndex, prodIndex) {
        let collections = this.state.collections;
        let product = collections[collIndex].products[prodIndex];
        if(product.sizes === undefined && product.shouldhave.length === 0) {
            this.add(collIndex, prodIndex);
        } else {
            window.location.href="/info/extra/"+product.id;
        }
    }

    add(collIndex, prodIndex) {
        let collections = this.state.collections;
        let product = collections[collIndex].products[prodIndex];
        
        if(product.quantity === undefined || product.quantity === 0) {
            product.quantityerror = true;
            this.setState({
                collections
            });
        } else {
            product.sum = true;
            window.WebApp.getCart().addExtra(product, () => {
                $('.finalize-snackbar .prodname').text(product.name);
                $('.finalize-snackbar').stop().slideDown();
                product.quantity = 0;
                product.totalCalc = 0;
                this.setState({
                    collections
                });
            });
        }
    }

    changeComposition(e, collIndex, prodIndex, compIndex) {
        this.addComposition(collIndex, prodIndex, compIndex, e.target.value);
    }

    changeSize(e, collIndex, prodIndex) {
        let collections = this.state.collections;
        let product = collections[collIndex].products[prodIndex];
        product.selectedsize = product.sizes[e.target.value];
        product.sizeindex = e.target.value;
        product.quantity = 0;
        product.totalCalc = 0;
        this.setState({
            collections
        }, () => this.calcPrice(collIndex, prodIndex));
    }

    addComposition(collIndex, prodIndex, compIndex, compProdIndex) {
        let collections = this.state.collections;
        let product = collections[collIndex].products[prodIndex];
        let result = window.WebApp.getCart().addComposition(product,compIndex,compProdIndex);
        if(result.success) {
            if(product.shouldhave[compIndex].pivot.max_quantity === 1) {
                for(var i = 0; i < product.shouldhave[compIndex].products_filtered.length; i++) {
                    product.shouldhave[compIndex].products_filtered[i].included = 0;
                }
            }
            product = result.product;

            this.setState({
                collections,
            }, () => this.calcPrice(collIndex, prodIndex, compIndex, prodIndex));
        }
    }

    lessComposition(collIndex, prodIndex, compIndex, compProdIndex) {
        let collections = this.state.collections;
        let product = collections[collIndex].products[prodIndex];
        if(product.shouldhave[compIndex].products_filtered[prodIndex].included > 0) {
            var result = window.WebApp.getCart().lessComposition(product,compIndex,compProdIndex,'allow0');
            result.product.shouldhave[compIndex].products_filtered[prodIndex].included--;
            this.setState({
                collections,
            }, () => this.calcPrice(collIndex, prodIndex, compIndex, prodIndex));
        }
    }

    checkout() {
        if(this.state.isLogged) {
            window.location.href = "/checkout";
        }else {
            localStorage.setItem('from', 'checkout');
            window.location.href = "/login";
        }
    }


    validateZipcode() {
        var zip1 = $('input[name="zip1"]').val();
        var zip2 = $('input[name="zip2"]').val();
        if (zip1.length == 4 && zip2.length == 3) {
          $(".zip").removeClass("error");
          $(".validate-zip").addClass("loading");
          this.checkZip(zip1, zip2);
        } else {
          $(".zip").addClass("error");
        }
      }
    
      checkZip(zip1, zip2) {
        window.WebApp.getNetwork().getLoading().doNotLoad(-1);
        window.WebApp.getCheckout().validateZipcode(zip1 + "-" + zip2, (result) => {
          $(".validate-zip").removeClass("loading");
          if (!result.invalidZip) {
            var data = { values: [{ key: "delivery_method", value: "1" }] };
            window.WebApp.getAccount().saveSession(data, (result2) => {
              window.WebApp.getCart().setZipcode(zip1 + "-" + zip2);
              this.setState({
                deliveryPopup: false,
                invalidZip: false,
                // schedulePopup: true,
                delivery_method: 1,
                zipcode: zip1 + "-" + zip2,
                store_id: result.zipcode.store_id,
              }); //, () => this.getSchedules());
              this.init();
            });
          } else {
            this.setState({
              invalidZip: true,
            });
          }
        });
      }

    saveStore(store) {
        if (store != null) {
          var data = {
            values: [
              { key: "store", value: store.id },
              { key: "delivery_method", value: "2" },
            ],
          };
          window.WebApp.getAccount().saveSession(data, (result) => {
            $('.loadingContainerv2').show();
            this.setState({
              storePopup: false,
              selectedStore: store
            });
            this.init();
          });
        }
      }

    render() {
        return (
            <div>
                <div className="finalize-snackbar">
                    <div className="main-container flex between">
                        <h5 className="green flex1">{strings.added1} <span className="prodname"></span> {strings.added2} <span className="pointer underline" onClick={() => this.checkout()}>{strings.added3}</span></h5>
                        <img alt="fechar-carrinho" src={window.fecharsnack} onClick={() => $('.finalize-snackbar').stop().slideUp()}/>
                    </div>
                </div>
                <div className="store header-padding">
                    <div className="collections">
                        <div className="flex start">
                            {this.state.collections.map((coll, collIndex) => {
                                if(coll.visible === 1) {
                                    return (
                                        <h5 key={collIndex} className={"collection" + (this.state.collection === collIndex ? " active" : "")} onClick={() => this.chageCollection(collIndex)}>{coll.name}</h5>
                                    )
                                }
                                return null;
                            })}
                        </div>
                    </div>
                    <div className="main-container">
                        {this.state.collections.map((coll, collIndex) => {
                            if(coll.visible === 1) {
                                return (
                                    <div key={collIndex} id={"#"+coll.name}>
                                        <h1 className="title collection-title" data-index={collIndex}>{coll.name}</h1>
                                        <div className={"collection-wrapper flex center collection-"+collIndex}>
                                            {coll.products.map((product, prodIndex) => {
                                                let prodname = product.name;
                                                return (
                                                    <div key={collIndex+""+prodIndex} className={"product flex column simple-product product-"+prodIndex + (product.active === 0 ? " inactive-product" : "")}>
                                                        <div className="flex1">
                                                            <div className="image pointer" onClick={() => window.location.href="/info/extra/"+product.id} style={{backgroundImage:(product.image !== null ? 'url('+this.state.url+product.image.url+')' : 'url('+window.placeholder+')')}}>
                                                            </div>
                                                            <h5 className="prod-name">{prodname}</h5>
                                                            {product.active === 0 &&
                                                                <h5 className="center-text">{strings.unavailable}</h5>
                                                            }
                                                            <div className="description" dangerouslySetInnerHTML={this.createMarkup(product.description)} />
                                                            <p className="prod-price f700 black">€{product.price.toFixed(2)}</p>
                                                        </div>
                                                        {product.shouldhave.length === 0 &&
                                                            <div>
                                                                <div className="flex between" style={{padding: "0px 16px 16px 16px"}}>
                                                                    <div className="flex between quantities flex1">
                                                                        <img className="pointer" alt="menos" src={window.menos} onClick={() => this.lessProduct(collIndex, prodIndex)}/>
                                                                        <h4>{product.quantity === undefined ? 0 : product.quantity}</h4>
                                                                        <img className="pointer" alt="mais" src={window.mais} onClick={() => this.moreProduct(collIndex, prodIndex)}/>
                                                                    </div>
                                                                    <button className="white-btn flex1" onClick={() => this.order(collIndex, prodIndex)}>
                                                                        {strings.order}
                                                                    </button>
                                                                </div>
                                                                {product.quantityerror &&
                                                                    <h6 className="center-text" style={{color:"red", marginBottom:"5px", marginTop:"0px"}}>* {strings.selectqty}</h6>
                                                                }
                                                            </div>
                                                        }
                                                        {product.shouldhave.length > 0 &&
                                                            <div style={{padding: "0px 16px 16px 16px"}}>
                                                                <button className="white-btn" style={{width:"100%"}} onClick={() => this.order(collIndex, prodIndex)}>
                                                                    {strings.personalize}
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            }
                            return null;
                        })}
                    </div>
                </div>
                {this.state.deliveryPopup && (
          <div className="delivery-popup">
            {window.deliveryScreenCloseIcon != "" && 
            <img
              className="close"
              src={window.deliveryScreenCloseIcon}
              onClick={() =>
                this.state.isChanging
                  ? this.setState({ deliveryPopup: false })
                  : (window.location.href = "/")
              }
            />
            }
            <div className="flex between">
              {this.state.store_delivery_methods.filter(
                (e) => e.name == "delivery"
              )[0] != undefined &&
                this.state.store_delivery_methods.filter(
                  (e) => e.name == "delivery"
                )[0].active == 1 && (
                  <div
                    className="left-side flex1"
                    style={{
                      backgroundColor:
                        window.deliveryScreenMainColor != ""
                          ? window.deliveryScreenMainColor
                          : "#000",
                    }}
                  >
                    <div
                      className="center-wrap center-wrap-margin"
                      style={{
                        color:
                          window.deliveryScreenTextColor != ""
                            ? window.deliveryScreenTextColor
                            : "#ffffff",
                      }}
                    >
                      <p className="title">{strings.homeDelivery}</p>
                      <p className="subtitle">{window.dpDeliverySentence}</p>
                      <p>{strings.zipcode}</p>
                      <input
                        style={{
                          color:
                            window.deliveryScreenTextColor != ""
                              ? window.deliveryScreenTextColor
                              : "#ffffff",
                          borderColor:
                            window.deliveryScreenTextColor != ""
                              ? window.deliveryScreenTextColor
                              : "#ffffff",
                        }}
                        type="text"
                        className="zip"
                        name="zip1"
                        placeholder="xxxx"
                        maxLength="4"
                      />
                      <input
                        style={{
                          color:
                            window.deliveryScreenTextColor != ""
                              ? window.deliveryScreenTextColor
                              : "#ffffff",
                          borderColor:
                            window.deliveryScreenTextColor != ""
                              ? window.deliveryScreenTextColor
                              : "#ffffff",
                          width:80
                        }}
                        type="text"
                        className="zip"
                        name="zip2"
                        placeholder="xxx"
                        maxLength="3"
                      />
                      <br />
                      {this.state.invalidZip && (
                        <p style={{ marginTop: "10px" }}>
                          {strings.zipErrorMsg}
                        </p>
                      )}
                      <p
                        className="custom-btn"
                        onClick={() => this.validateZipcode()}
                      >
                        {strings.validate}
                      </p>
                    </div>
                  </div>
                )}
              {this.state.store_delivery_methods.filter(
                (e) => e.name == "takeaway"
              )[0] != undefined &&
                this.state.store_delivery_methods.filter(
                  (e) => e.name == "takeaway"
                )[0].active == 1 && (
                  <div
                    className="right-side flex1"
                    style={{
                      backgroundColor:
                        window.deliveryScreenSecondaryColor != ""
                          ? window.deliveryScreenSecondaryColor
                          : "#000",
                    }}
                  >
                    <div
                      className="center-wrap"
                      style={{
                        color:
                          window.deliveryScreenTextColor != ""
                            ? window.deliveryScreenTextColor
                            : "#ffffff",
                      }}
                    >
                      <p className="title">{strings.takeAway}</p>
                      <p className="subtitle">{window.dpTakeawaySentence}</p>
                      <p
                        className="custom-btn wmarg"
                        style={{
                          color:
                            window.deliveryScreenTextColor != ""
                              ? window.deliveryScreenTextColor
                              : "#ffffff",
                          borderColor:
                            window.deliveryScreenTextColor != ""
                              ? window.deliveryScreenTextColor
                              : "#ffffff",
                        }}
                        onClick={() => {
                          if (this.state.stores.length > 1) {
                            this.setState({
                              storePopup: true,
                              deliveryPopup: false,
                              delivery_method: 2,
                            });
                          } else {
                            this.setState({
                              selectedStore: this.state.stores[0],
                              deliveryPopup: false,
                            });
                            this.saveStore(this.state.stores[0]);
                          }
                        }}
                      >
                        {this.state.stores.length > 1
                          ? strings.chooseShop
                          : strings.enterShop}
                      </p>
                    </div>
                  </div>
                )}
            </div>
          </div>
        )}
                {this.state.storePopup && (
          <div className="delivery-popup">
            <div
              className="contact-section flex start"
              style={{
                backgroundColor:
                  window.deliveryScreenSecondaryColor != ""
                    ? window.deliveryScreenSecondaryColor
                    : "#000",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                className="contact-block"
                style={{
                  color:
                    window.deliveryScreenTextColor != ""
                      ? window.deliveryScreenTextColor
                      : "#ffffff",
                }}
              >
                <div className="contact-txt" style={{ textAlign: "center" }}>
                  <h1>{strings.deliveryChooseStore}</h1>
                </div>
              </div>
              <div className={"storeListBlock"}>
                {this.state.stores.map((store, index) => {
                  return (
                    <div
                      className={
                        "contact-block border heff" +
                        (this.state.selectedStore != null &&
                        this.state.selectedStore.id == store.id
                          ? " active"
                          : "")
                      }
                      style={{
                        color:
                          window.deliveryScreenTextColor != ""
                            ? this.state.selectedStore != null &&
                              this.state.selectedStore.id == store.id
                              ? window.deliveryScreenSelectedTextColor
                              : window.deliveryScreenTextColor
                            : "#ffffff",

                        borderColor:
                          window.deliveryScreenTextColor != ""
                            ? this.state.selectedStore != null &&
                              this.state.selectedStore.id == store.id
                              ? window.deliveryScreenSelectedTextColor
                              : window.deliveryScreenTextColor
                            : "#ffffff",
                      }}
                      key={index}
                      onClick={() => {
                        this.setState({ selectedStore: store });
                        this.saveStore(store);
                      }}
                    >
                      <div
                        className="store-info"
                        style={{
                          color:
                            window.deliveryScreenTextColor != ""
                              ? this.state.selectedStore != null &&
                                this.state.selectedStore.id == store.id
                                ? window.deliveryScreenSelectedTextColor
                                : window.deliveryScreenTextColor
                              : "#ffffff",
                        }}
                      >
                        <p className="name">{store.name}</p>
                        <p className="title">{strings.location}</p>
                        <p>{store.address}</p>
                      </div>
                    </div>
                  );
                })}
                <p
                  style={{ marginTop: "20px", fontSize: "16px" }}
                  className="contact-block"
                >
                  <u
                    onClick={() =>
                      this.setState({
                        storePopup: false,
                        deliveryPopup: true,
                      })
                    }
                    style={{
                      color:
                        window.deliveryScreenTextColor != ""
                          ? window.deliveryScreenTextColor
                          : "#ffffff",
                      cursor: "pointer",
                    }}
                  >
                    {strings.goBack}
                  </u>
                </p>
              </div>
            </div>
          </div>
        )}
            </div>
        );
    }
}
